/** Shopify themes expose loadFeatures before they expose customerPrivacy.
 * Loading the API reads the shop's actual permissions; it never grants consent.
 * https://shopify.dev/docs/api/customer-privacy#loading-the-customer-privacy-api
 */
const requested = new WeakSet<object>();
const PRIVACY_FEATURE = { name: "consent-tracking-api", version: "0.1" };
const LOAD_WARNING = "[TheSocialTap] Shopify privacy API could not be loaded; keeping configured consent defaults.";

export function loadShopifyPrivacy(onReady: () => void): void {
  const shopify = window.Shopify;
  if (!shopify || shopify.customerPrivacy || typeof shopify.loadFeatures !== "function") return;
  if (requested.has(shopify)) return;
  requested.add(shopify);
  try {
    shopify.loadFeatures([PRIVACY_FEATURE], error => {
      if (error) { console.warn(LOAD_WARNING); return; }
      onReady();
    });
  } catch {
    console.warn(LOAD_WARNING);
  }
}
